<template>
  <div class="comments-tab">
    <AddCommentButton
      class="add-comment-btn"
      type="pseudo-link"
      :post-comment-endpoint="$constants.QUESTIONS.ADD_PRODUCT_QUESTION_ENDPOINT"
      :form-type="$constants.QUESTIONS.FORM_TYPE_PRODUCT"
      :product-id="productId"
      :is-questions="true"
    />
    <WithTitle class="comments" v-if="comments.comments.length" :title="$t('questions.title')">
      <div v-if="commentsWithMediaLoaded && media.length" class="product-comments__media-wrap">
        <h3 class="product-comments__media-title">{{ $t('review.media.title') }}</h3>
        <CommentsMediaSlider
          :media="media"
          :endpoint="$constants.QUESTIONS.ADD_PRODUCT_QUESTION_ENDPOINT"
          :product-id="productId"
          :is-questions="true"
        />
      </div>
      <CommentsList
        :endpoint="$constants.QUESTIONS.ADD_PRODUCT_QUESTION_ENDPOINT"
        :product-id="productId"
        :is-questions="true"
      />
      <CommentsShowMore
        :comments="comments"
        :is-loading="isLoading"
        :get-comments-endpoint="$constants.QUESTIONS.GET_PRODUCT_QUESTIONS_ENDPOINT"
        :product-id="productId"
        :is-questions="true"
      />
    </WithTitle>
    <WithTitle :title="$t('questions.empty_title')">
      <EmptyReviews
        v-if="!comments.comments.length && !auth"
        :type="$constants.QUESTIONS.FORM_TYPE_PRODUCT"
        :endpoint="$constants.QUESTIONS.ADD_PRODUCT_QUESTION_ENDPOINT"
        :product-id="productId"
        :is-questions="true"
      />
      <span v-else-if="!auth" class="comments__auth-text">{{ $t('questions.need_auth') + ' ' }}<button class="comments__auth-btn" @click="$modal.show('auth-modal')">{{ $t('auth_link') }}</button></span>
      <QuestionsForm
        :type="$constants.QUESTIONS.FORM_TYPE_PRODUCT"
        :endpoint="$constants.QUESTIONS.ADD_PRODUCT_QUESTION_ENDPOINT"
        :product-id="productId"
        v-else
      />
    </WithTitle>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import WithTitle from '../layouts/WithTitle'
import CommentsList from '../../../components/comments/CommentsList'
// import CommentsForm from '../../../components/comments/CommentsForm'
import QuestionsForm from '@/components/questions/QuestionsForm.vue'
import EmptyReviews from '../../../components/product/product-page/EmptyReviews'
import CommentsMediaSlider from '../../../components/comments/CommentsMediaSlider'
import AddCommentButton from '../../../components/comments/AddCommentButton'
import CommentsShowMore from '../../../components/comments/CommentsShowMore'

export default {
  name: 'ProductQuestions',
  components: {
    AddCommentButton,
    CommentsMediaSlider,
    EmptyReviews,
    QuestionsForm,
    CommentsShowMore,
    CommentsList,
    WithTitle
  },
  computed: {
    ...mapState({
      auth: state => state.user.auth,
      productId: state => state.productInfo.productInfo.productId,
      comments: state => state.questions.comments,
      commentsWithMedia: state => state.questions.commentsWithMedia,
      isLoading: state => state.questions.isLoading,
      commentsCount: state => state.questions.comments.total_count
    }),
    commentsWithMediaLoaded () {
      return !!Object.keys(this.commentsWithMedia).length
    },
    media () {
      if (this.commentsWithMediaLoaded) return this.commentsWithMedia.media
      return null
    }
  },
  methods: {
    ...mapActions('questions', ['FETCH_QUESTIONS'])
  },
  mounted () {
    const params = {
      id: this.productId,
      endpoint: this.$constants.QUESTIONS.GET_PRODUCT_QUESTIONS_ENDPOINT,
      onlyWithMedia: 1
    }

    this.FETCH_QUESTIONS(params)
  }
}
</script>

<style scoped lang="sass">

.comments-tab
  position: relative

.comments
  margin-bottom: 80px

.product-comments__progress-wrap
  display: block
  width: max-content
  margin: 40px auto

.product-comments__progress
  position: relative
  width: 200px
  height: 2px
  background-color: #e7e7e7

  &--active
    position: absolute
    left: 0
    top: 0
    bottom: 0
    background-color: $main-color

.product-comments__progress-text
  display: block
  margin-bottom: 20px
  font-size: 14px
  color: $placeholder-color
  text-align: center

.product-comments__show-more
  margin: 0 auto

.comments__auth-text
  display: block
  margin-bottom: 20px

.comments__auth-btn
  color: #3e77aa
  font-size: 14px
  background: transparent
  border-color: transparent
  padding: 0
  border-bottom: 1px dashed #3e77aa
  cursor: pointer
  display: inline-block

  &:hover
    border-color: transparent

.add-comment-btn
  position: absolute
  top: 7px
  right: 0

.product-comments__media-title
  margin: 0 0 20px
  font-size: 18px
  font-weight: 500

  +mmin($tablet--hor)
    margin: 0 0 15px

.product-comments__media-wrap
  margin: 40px 0

</style>
